import script from "./boardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./boardHeader.vue?vue&type=script&setup=true&lang=js"

import "./boardHeader.vue?vue&type=style&index=0&id=d42bb876&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d42bb876"]])

export default __exports__